<template>
  <div class="container-fluid">
    <nav class="global-nav">
      <Logo class="intro" variant="primary" />
    </nav>

    <main class="container">
      <article>
        <section>
          <picture>
            <source
              media="(min-width: 1200px)"
              :srcset="require('@/assets/intro.png')"
            />
            <source
              media="(min-width: 768px)"
              :srcset="require('@/assets/intro-768.png')"
            />
            <img
              :src="require('@/assets/intro-536.png')"
              alt="감영길 예술가의 거리 이미지"
            />
          </picture>
          <header>
            <h1 variant="primary">
              반응형 브랜딩과 감영길예술가의 거리
            </h1>
          </header>
          <p>
            <Lettertype /> 는 충남 공주시 반죽동에 위치한 일(一)자 형태로 끝이
            양쪽으로 나뉘는 거리이다. 이 거리에는 포토스튜디오, 캘리그라피,
            가죽공방, 민화 등의 다양한 예술가들이 모여 있고 주말 밤에 길을 따라
            부스를 설치하여 플리마켓 형태로 판매하는 "문화재 야행"이라는 행사를
            열어 작품들을 판매하기도 한다. 이 길의 형태를 표현하는 브랜딩을
            하였고, 이 일자의 형태만 보아도 '감영길예술가의 거리'를 느낄 수
            있도록 하였다.
          </p>
          <figure>
            <img :src="require('@/assets/map.png')" alt="감영길 지도" />
            <figcaption>
              <small>감영길의 지도 이미지, 출처: 네이버 지도</small>
            </figcaption>
          </figure>
        </section>
      </article>
      <article>
        <section>
          <p>
            반응형 브랜딩(Responisve Branding)은, 로고가 규칙을 갖고 유연하게
            느낌을 제공하는 플렉서블 아이덴티티(FI: Flexible Identity, 이하
            FI)에서 시작하여 대지의 크기, 화면의 크기에 따라 수동으로 브랜드를
            제작해야하는 아쉬움을 더 보완해보고자 화면의 크기에 반응하여
            웹사이트를 보여주는 반응형 웹(Responisve Web)의 특징을 가져와 브랜드
            로고, 심볼이 거의 모든 화면에 동일한 규칙이 유지되도록 한다.
          </p>
        </section>
        <section>
          <Logo
            class="anime-el"
            variant="primary"
            :style="{ marginBottom: '-1rem' }"
          />
          <Logo
            class="anime-el"
            variant="secondary"
            :style="{ marginBottom: '-1rem' }"
          />
          <Logo
            class="anime-el"
            variant="primary"
            :style="{ marginBottom: '-1rem' }"
          />
          <Logo
            class="anime-el"
            variant="secondary"
            :style="{ marginBottom: '-1rem' }"
          />
        </section>
        <section>
          <p>
            이런 느낌의 브랜딩을 표현할 적절한 단어를 찾지 못해 '반응형
            브랜딩'으로 임시로 이름을 지었고, 이를 함께 만들 팀원과 이런 브랜딩
            작업을 진행해보려고 한다.
            <br />
            자세한 내용은 브런치에서 글로 작성하였다.
            <a href="https://brunch.co.kr/@seoro-malgm/27">브런치 글 주소</a>
          </p>
        </section>
      </article>
    </main>
  </div>
</template>

<script>
import Logo from "@/components/Logo";
import Lettertype from "@/components/Lettertype";
export default {
  name: "Home",
  components: {
    Logo,
    Lettertype,
  },
  methods: {
    animeInit() {
      this.$anime({
        targets: ".intro",
        width: [0, "100%"],
        easing: "easeOutExpo",
        duration: 4000,
      });
      this.$anime({
        targets: "main",
        opacity: [0, 100],
        delay: 3000,
        easing: "linear",
        duration: 20000,
      });
      this.$anime({
        targets: ".anime-el",
        width: (el, i, l) => {
          return `${Math.random() * 100 + 10}%`;
        },
        delay: (el, i, l) => {
          return `${Math.random() * 300 * i}`;
        },
        loop: true,
        direction: "alternate",
        easing: "easeInOutQuad",
      });
    },
  },
  mounted() {
    this.animeInit();
  },
};
</script>

<style scoped></style>
